<script setup lang="ts">
defineProps<{
  active?: boolean;
}>();
</script>

<template>
  <template v-if="!active">
    <svg xmlns="http://www.w3.org/2000/svg" id="Livello_1" data-name="Livello 1" viewBox="0 0 50 50" fill="currentColor">
      <path
        d="m8.29 15.8-.3.18h.67l-.04-.08 1.54-.9-.05-.1c-.29-.58-.5-1.11-.63-1.63-.19-.67-.28-1.43-.28-2.25 0-2.35.84-4.38 2.49-6.04 1.65-1.65 3.68-2.49 6.05-2.49s4.38.84 6.04 2.49c1.65 1.64 2.49 3.68 2.49 6.04 0 .82-.1 1.58-.28 2.25-.15.55-.36 1.09-.63 1.62l-.05.1 1.77 1.03.06-.11c.36-.69.65-1.4.84-2.12.24-.89.36-1.82.36-2.77 0-2.93-1.04-5.45-3.08-7.49S20.69.45 17.76.45s-5.45 1.04-7.5 3.09c-2.04 2.04-3.08 4.57-3.08 7.5 0 .92.12 1.84.36 2.75.19.69.45 1.37.78 2.02Z"
      />
      <path
        d="M43.73 26.23C42.5 25 41.04 24.4 39.28 24.4H27.02v2.05h12.26c1.2 0 2.21.41 3.01 1.22.81.8 1.22 1.81 1.22 3.01v9.67c0 2-.71 3.72-2.1 5.1-1.39 1.37-3.11 2.07-5.12 2.07H24.5c-1.06 0-2.08-.21-3.03-.61A6.086 6.086 0 0 1 19.01 45L9.13 31.95l.45-.55 9.02 4.46.18.09V11.03c0-.29-.1-.53-.3-.73-.2-.2-.44-.3-.74-.3s-.54.09-.74.3c-.2.2-.3.44-.3.73V32.4l-8.77-4.33a2.225 2.225 0 0 0-1.56-.28c-.55.1-1.02.36-1.43.81l-.52.58 12.78 16.9a8.207 8.207 0 0 0 3.2 2.59c1.25.58 2.59.88 3.97.89h11.91c2.54 0 4.74-.89 6.55-2.68 1.81-1.79 2.72-3.99 2.72-6.53v-9.67c0-1.76-.6-3.22-1.83-4.45Z"
      />
    </svg>
  </template>
  <template v-else>
    <svg xmlns="http://www.w3.org/2000/svg" id="Livello_1" data-name="Livello 1" viewBox="0 0 50 50" fill="currentColor">
      <path d="M15.82 20.06v-8.44c0-2.45 1.99-4.44 4.44-4.44s4.44 1.99 4.44 4.44v8.31c3.45-1.69 5.83-5.23 5.83-9.33 0-5.75-4.66-10.4-10.4-10.4S9.73 4.86 9.73 10.6c0 4.21 2.5 7.82 6.09 9.46Z" />
      <path
        d="M36.02 49.69c2.23 0 4.16-.79 5.75-2.36 1.58-1.57 2.39-3.49 2.39-5.72v-9.57c0-1.47-.48-2.64-1.51-3.67s-2.19-1.51-3.67-1.51H22.89V12.38c0-1.43-1.17-2.6-2.6-2.6s-2.6 1.17-2.6 2.6v23.03L7.5 30.38c-.37-.21-.68-.23-.86-.19-.32.06-.56.19-.79.42l12.12 16.03c.74.99 1.67 1.74 2.77 2.24 1.14.53 2.36.79 3.62.79h11.66Z"
      />
    </svg>
  </template>
</template>
